import { configureStore } from '@reduxjs/toolkit';
import Menu from "./Menu";
import Disputes from "./Disputes";
import Promotions from "./Promotions";
import RoleManagement from "./RoleManagement";
import Theme from "./Theme";
import Customizations from "./Customizations";
import merchantDashboard from "./MerchantDasboard";
import merchants from "./MerchantsUser";
import merchantAnalytics from "./MerchantAnalytics";
import merchantAnalyticsOverview from "./MerchantAnalyticsOverview";
import salesDetailed from "./SalesDetailed";
import categorySales from "./CategorySales";
import itemSales from "./ItemSales";
import trendingItems from "./TrendingItems";
import Options from "./Options";
import Settings from "./Settings";
import deliveryCostAnalysis from "./DeliveryCostAnalysis";
import profitMargins from "./ProfitMargins";
import itemPerformanceComparison from "./ItemPerformanceComparison";
import customers from "./Customers";
import popularItems from "./PopularItems";
import customRangeReports from "./CustomRangeReports";
import weeklyReports from "./WeeklyReports";
import monthlyReports from "./MonthlyReports";
import merchantEarnings from "./MerchantEarnings";
import activeSessionsAndDevices from "./ActiveSessionsAndDevices";
import actionLogs from "./ActionLogs";
import stores from "./UserStores";
import deviceTypes from "./DeviceTypes";
import devices from "./Devices";
import loyalty from "./Loyalty";
import auth from "./auth/authSlice";
import items from "./Items";
import staffDashboard from "./StaffDashboard";
import managerReports from "./ManagerReports";
import staffReports from "./StaffReports";
import adminReportsReducer from "./AdminReports";
import orders from "./ordersSlice";
import deviceAssignment from "./DeviceAssignment";
import adminDashboard from "./AdminDashboard";
import schedules from "./schedulesSlice";
import merchantCategories from "./merchantCategoriesSlice";
import payments from "./paymentsSlice";
import adminAnalytics from "./adminAnalyticsSlice";
import merchantEarningsOverview from "./merchantEarningsSlice";
import emailTestModal from "./emailTestModalSlice";
import emailTemplateTest from "./emailTemplateTestSlice";

export const store = configureStore({
    reducer: {
        menu: Menu,
        disputes: Disputes,
        promotions: Promotions,
        roleManagement: RoleManagement,
        theme: Theme,
        customizations: Customizations,
        merchantDashboard: merchantDashboard,
        merchants: merchants,
        merchantAnalytics: merchantAnalytics,
        merchantAnalyticsOverview: merchantAnalyticsOverview,
        salesDetailed: salesDetailed,
        categorySales: categorySales,
        itemSales: itemSales,
        trendingItems: trendingItems,
        options: Options,
        settings: Settings,
        deliveryCostAnalysis: deliveryCostAnalysis,
        profitMargins: profitMargins,
        itemPerformanceComparison: itemPerformanceComparison,
        customers: customers,
        popularItems: popularItems,
        customRangeReports: customRangeReports,
        weeklyReports: weeklyReports,
        monthlyReports: monthlyReports,
        merchantEarnings: merchantEarnings,
        activeSessionsAndDevices: activeSessionsAndDevices,
        actionLogs: actionLogs,
        stores: stores,
        deviceTypes: deviceTypes,
        devices: devices,
        loyalty: loyalty,
        auth: auth,
        items: items,
        staffDashboard: staffDashboard,
        managerReports: managerReports,
        staffReports: staffReports,
        adminReports: adminReportsReducer,
        orders,
        deviceAssignment,
        adminDashboard,
        schedules,
        merchantCategories,
        payments,
        adminAnalytics,
        merchantEarningsOverview,
        emailTestModal,
        emailTemplateTest,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;

